import { RouteObject } from 'react-router'
import { CreateAppointmentModal } from '../pages/create'
import { AppointmentPage } from '../pages/appointment'
import { AppointmentsPage } from '../pages/appointments'
import { AppointmentRequestsPage } from '../pages/appointment-requests'
import { EditAppointmentNotesModal } from '../pages/edit-notes'
import { RescheduleAppointmentModal } from '../pages/reschedule'

export enum AppointmentRoutePath {
  Appointments = '/appointments',
  AppointmentsRequests = '/requests',
  AppointmentsView = '/appointments/:id',
  AppointmentsCreate = '/appointments/create',
  AppointmentsNotesEdit = '/appointments/:id/edit-notes',
  AppointmentsReschedule = '/appointments/:id/reschedule',
}

export const protectedAppointmentRoutes: RouteObject[] = [
  {
    path: AppointmentRoutePath.AppointmentsRequests,
    element: <AppointmentRequestsPage />,
  },
  {
    path: AppointmentRoutePath.Appointments,
    element: <AppointmentsPage />,
    children: [
      {
        path: AppointmentRoutePath.AppointmentsCreate,
        element: <CreateAppointmentModal />,
      },
    ],
  },
  {
    path: AppointmentRoutePath.AppointmentsView,
    element: <AppointmentPage />,
    children: [
      {
        path: AppointmentRoutePath.AppointmentsNotesEdit,
        element: <EditAppointmentNotesModal />,
      },
      {
        path: AppointmentRoutePath.AppointmentsReschedule,
        element: <RescheduleAppointmentModal />,
      },
    ],
  },
]
